import { DatePipe } from '@angular/common';
import { Injectable, Pipe, PipeTransform } from '@angular/core';

/**
 * 🧨 WHY IS THIS A PIPE WHEN ITS NOT USED AS A PIPE?
 */
@Pipe({
  name: 'dateFormat',
})
@Injectable({
  providedIn: 'root',
})
export class DateFormatPipe extends DatePipe implements PipeTransform {
  private static readonly DATE_FORMAT_GERMAN = 'dd.MM.yyyy';
  private static readonly DATE_FORMAT_GLOBAL = 'yyyy-MM-dd';

  /**
   * Returns given date in yyyy-MM-dd
   */
  public transformDateToGlobalFormat(value: any): any {
    return super.transform(value, DateFormatPipe.DATE_FORMAT_GLOBAL);
  }

  /**
   * Returns given date in dd.MM.yyy
   */
  public transformDateToGermanFormat(value: any): any {
    return super.transform(value, DateFormatPipe.DATE_FORMAT_GERMAN);
  }

  public transformFromDotSeparatorToDate(value: any): any {
    const from = value.split('.');
    return new Date(from[2], from[1] - 1, from[0]);
  }

  /**
   * Returns date format (dd.MM.yyyy) for e.g. a label
   */
  public getDateFormatGerman(): string {
    return DateFormatPipe.DATE_FORMAT_GERMAN;
  }

  /**
   * Returns date format (yyyy-MM.dd) for e.g. a label
   */
  public getDateFormatGlobal(): string {
    return DateFormatPipe.DATE_FORMAT_GLOBAL;
  }
}
